export default class ModalZoomImageController {
  /* @ngInject */
  constructor(close, images, activeImage, $element) {
    this.close = close;
    this.title = 'Zoom Image';
    this.images = images;
    this.activeIndex = 0;
    this.element = $element[0];
    this.onClickProductImage = this.onClickProductImage.bind(this);
    this.setActiveImage(activeImage);
    document.body.classList.add('modal-zoom--is-visible');
  }

  onClickProductImage(image) {
    this.setActiveImage(image);
  }

  setActiveImage(newImage = {}) {
    this.activeIndex = this.images.findIndex(img => img.url === newImage.url) || 0;
    this.activeImage = this.images.find(img => img.url === newImage.url) || {};
    setTimeout(() => {
      const domContainerActiveImage = this.element.querySelector('.modal-zoom__image');
      const domActiveImage = domContainerActiveImage.children[0];
      domActiveImage.complete
        ? this.centerScroll(domContainerActiveImage)
        : domActiveImage.addEventListener('load', () => this.centerScroll(domContainerActiveImage));
    }, 0);
  }

  centerScroll(element) {
    element.scrollTop = (element.scrollHeight / 2) - (element.clientHeight / 2);
    element.scrollLeft = (element.scrollWidth / 2) - (element.clientWidth / 2);
  }

  onClose() {
    document.body.classList.remove('modal-zoom--is-visible');
    this.close({
      activeImage: this.activeImage,
      activeIndex: this.activeIndex,
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-zoom-image/modal-zoom-image.controller.js